export const FETCH_POSITIONS_REQUEST = 'FETCH_POSITIONS_REQUEST';
export const FETCH_POSITIONS_SUCCESS = 'FETCH_POSITIONS_SUCCESS';
export const FETCH_POSITIONS_FAILURE = 'FETCH_POSITIONS_FAILURE';

export const SAVE_POSITION_REQUEST = 'SAVE_POSITION_REQUEST';
export const SAVE_POSITION_SUCCESS = 'SAVE_POSITION_SUCCESS';
export const SAVE_POSITION_FAILURE = 'SAVE_POSITION_FAILURE';

export const CHANGE_POSITION_STATUS_REQUEST = 'CHANGE_POSITION_STATUS_REQUEST';
export const CHANGE_POSITION_STATUS_SUCCESS = 'CHANGE_POSITION_STATUS_SUCCESS';
export const CHANGE_POSITION_STATUS_FAILURE = 'CHANGE_POSITION_STATUS_FAILURE';

export const FETCH_SKILL_MAPPING_REQUEST = 'FETCH_SKILL_MAPPING_REQUEST';
export const FETCH_SKILL_MAPPING_SUCCESS = 'FETCH_SKILL_MAPPING_SUCCESS';
export const FETCH_SKILL_MAPPING_FAILURE = 'FETCH_SKILL_MAPPING_FAILURE';

export const SAVE_SKILL_MAPPING_REQUEST = 'SAVE_SKILL_MAPPING_REQUEST';
export const SAVE_SKILL_MAPPING_SUCCESS = 'SAVE_SKILL_MAPPING_SUCCESS';
export const SAVE_SKILL_MAPPING_FAILURE = 'SAVE_SKILL_MAPPING_FAILURE';

export const CHANGE_SKILL_MAPPING_STATUS_REQUEST = 'CHANGE_SKILL_MAPPING_STATUS_REQUEST';
export const CHANGE_SKILL_MAPPING_STATUS_SUCCESS = 'CHANGE_SKILL_MAPPING_STATUS_SUCCESS';
export const CHANGE_SKILL_MAPPING_STATUS_FAILURE = 'CHANGE_SKILL_MAPPING_STATUS_FAILURE';

export const FETCH_POSITIONS_BY_DEPT_ROLE_REQUEST = 'FETCH_POSITIONS_BY_DEPT_ROLE_REQUEST';
export const FETCH_POSITIONS_BY_DEPT_ROLE_SUCCESS = 'FETCH_POSITIONS_BY_DEPT_ROLE_SUCCESS';
export const FETCH_POSITIONS_BY_DEPT_ROLE_FAILURE = 'FETCH_POSITIONS_BY_DEPT_ROLE_FAILURE';

export const FETCH_COMPETENCY_LIST_REQUEST = 'FETCH_COMPETENCY_LIST_REQUEST';
export const FETCH_COMPETENCY_LIST_SUCCESS = 'FETCH_COMPETENCY_LIST_SUCCESS';
export const FETCH_COMPETENCY_LIST_FAILURE = 'FETCH_COMPETENCY_LIST_FAILURE';
